import { apiClient } from "@/core/api/ApiClient";
import { EntityType, TenantRequestDto } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: TenantRequestDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function TenantRequestDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.TenantRequest}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.tenantRequestsApi.apiV1TenantToTenantTenantRequestsTenantRequestIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          tenantRequestId: params.entityId,
        });
      }}
      {...otherProps}
    />
  );
}
